<template>

  <div>
    <v-parallax src="./images/parrallax/18.png" height='600'>
      <v-layout align-center justify-center row wrap pa-2>
        <v-flex xs12 md3>
          <p class='display-3 font-weight-medium text-center blue--text text--darken-3 pt-3'>Features</p>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center row wrap>
        <v-flex xs6 md2>
          <center>
            <h2 class='blue--text text--darken-3 hidden-sm-and-down'>Mobile</h2>
            <v-img class='elevation-10 contain' max-height="400" max-width="200" src='../images/feature/8.png' />
          </center>
        </v-flex>
        <v-flex xs0 md4 text-center hidden-sm-and-down>
          <h2 class='blue--text text--darken-3'> Desktop</h2>
          <v-img src='../images/desktop.png' contain>
          </v-img>
        </v-flex>
        <v-flex xs6 md2 hidden-sm-and-down>
          <center>
            <h2 class='blue--text text--darken-3'>Web Widget</h2>
            <v-img class='elevation-10 contain' max-height="400" max-width="200" src='../images/feature/7.png' />
          </center>
        </v-flex>
      </v-layout>
    </v-parallax>

    <v-layout row wrap justify-center ma-5 text-center>
      <v-flex xs12 sm4 md2 ma-1 :key="index" v-for="(channel, index) in channels">
        <v-layout row wrap align-center justify-center ma-2>
          <v-flex xs12 md10 text-xs-center>
            <v-icon size="100" color='light-blue'>{{ channel.icon }}</v-icon>
          </v-flex>
          <v-flex xs8 sm12>
            <P class="headline">{{ channel.headline}}</p>
          </v-flex>
          <v-flex xs8 sm12>
            {{ channel.desc }}
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row wrap justify-center ma-5 text-center>
      <v-flex xs12 sm4 md2 ma-1 :key="index" v-for="(secondchannel, index) in secondchannels">
        <v-layout row wrap align-center justify-center ma-2>
          <v-flex xs12 md10 text-xs-center>
            <v-icon size="100" color='light-blue'>{{ secondchannel.icon }}</v-icon>
          </v-flex>
          <v-flex xs8 sm12>
            <P class="headline">{{ secondchannel.headline}}</p>
          </v-flex>
          <v-flex xs8 sm12>
            {{ secondchannel.desc }}
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>



    <v-layout row wrap ma-5>

      <v-layout row wrap fill-height align-center justify-center pa-5>
        <v-flex md5 order-xs2 order-md1 pa-5>
          <h3 class='display-1 font-weight-medium text-xs-center'>Two-Way Text Messaging</h3>
          <p>
            With customers today utilizing their mobile phones to communicate and find information and an estimated 98% open rate on
            SMS, businesses are investing in mobile communication and marketing. SMS is direct to your customer, cost-effective
            and simple to utilize. SMS provides the channels to communicate news, information, special offers, rewards and
            incentives. Communicate openly with 2-way communication with image support with the Engage Message Platform.
          </p>
        </v-flex>
        <v-flex md3 order-xs1 pa-5>
          <v-card style="border-radius: 5px">
            <v-img src='../images/parrallax/4.jpg' class='elevation-15' />
          </v-card>
        </v-flex>

      </v-layout>
      <v-divider class='hidden-md-and-up'></v-divider>
      <v-layout row wrap fill-height align-center justify-center pa-5>
        <v-flex md3 pa-5 order-xs1>
          <v-card style="border-radius: 5px">
            <v-img src='../images/feature/2.png' class='elevation-15' />
          </v-card>
        </v-flex>
        <v-flex md5 pa-5 order-xs2>
          <h3 class='display-1 font-weight-medium text-xs-center'>Mobile iOS & Android</h3>
          <blockquote>
            Install the Engage Messaging Platform directly to your mobile device with Android or iOS. Keep your conversations on the
            go with your staff able to respond anywhere they have cell service from one central messaging platform that is
            Engage. Always keep a pulse on your SMS messaging on the go and receive new message notifications on your mobile
            device.
          </blockquote>
        </v-flex>
      </v-layout>
      <v-divider class='hidden-md-and-up'></v-divider>
      <v-layout row wrap fill-height align-center justify-center pa-5>
        <v-flex md5 pa-5 order-xs2 order-md1>
          <h3 class='display-1 font-weight-medium text-xs-center'>Notifications</h3>
          <blockquote>
            Keeping on top of your conversations and ensure a quick response time with notifications. Users will receive
            notifications whenever a new response is received from a conversation, they are active in. Notifications will pop
            on Desktop and Mobile devices ensuring you see the notification no matter what device you are using.
          </blockquote>
        </v-flex>
        <v-flex md3 pa-5 order-xd1 order-md2>
          <v-card style="border-radius: 5px">
            <v-img src='../images/feature/5.png' class='elevation-15' />
          </v-card>
        </v-flex>
      </v-layout>
      <v-divider class='hidden-md-and-up'></v-divider>
      <v-layout row wrap fill-height align-center justify-center pa-5>
        <v-flex md3 pa-5>
          <v-card style="border-radius: 5px">
            <v-img src='../images/feature/1.png'>
            </v-img>
          </v-card>
        </v-flex>
        <v-flex md5 pa-5>
          <h3 class='display-1 font-weight-medium text-xs-center'>Website Widget</h3>
          <blockquote>
            Upgrade your website with an SMS Widget allowing your customers to start a text conversation with your business. With multi
            location support your customers can choose the location closest to them to begin a text conversation. A customizable
            theme allows the Engage widget to match your existing web design.
          </blockquote>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-parallax src="./images/parrallax/2.jpg" height='600'>

      <v-layout align-center justify-center row>
        <v-flex md8 class="text-center">
          <blockquote class='display-1 text-uppercase font-weight-bold white--text'>
            Time to put the conversation in your customer's hands.
          </blockquote>
        </v-flex>
      </v-layout>

    </v-parallax>

    <v-layout row wrap ma-5>
      <v-layout row wrap fill-height align-center justify-center pa-5>
        <v-flex md5 pa-5 order-xs2 order-md1>
          <h3 class='display-1 font-weight-medium text-xs-center'>Conversation Filters</h3>
          <blockquote>
            Keep your conversations organized by type or track the status of a conversation as it progresses. With 18 color coded avatars
            you are able to filter on the color code you want to work with. Filter conversations by sales leads, awaiting reviews,
            order complete and much more to fit the needs of your business.
          </blockquote>
        </v-flex>
        <v-flex md3 pa-5 order-xs1 order-md2>
          <v-img src='../images/feature/9.png' />
        </v-flex>
      </v-layout>
      <v-divider class='hidden-md-and-up'></v-divider>
      <v-layout row wrap fill-height align-center justify-center pa-5>
        <v-flex md3 pa-5>
          <v-img src='../images/feature/11.png' />
        </v-flex>
        <v-flex md5 pa-5>
          <h3 class='display-1 font-weight-medium text-xs-center'>Quick Answer Templates</h3>
          <blockquote>
            Maintain consistency and professionalism by using preset messages. Customize your responses in a simple
            drop-down menu to prepopulate conversation text. Save time with pre-set messages to your commonly asked questions.
            Include links to offers, reviews and surveys for your customers to fill out right from their mobile
            device.
          </blockquote>
        </v-flex>
      </v-layout>
      <v-divider class='hidden-md-and-up'></v-divider>
      <v-layout row wrap fill-height align-center justify-center pa-5>
        <v-flex md5 pa-5 order-xs2 order-md1>
          <h3 class='display-1 font-weight-medium text-xs-center'>Multi Location</h3>
          <blockquote>
            Engage allows you to see all Engage Locations from one app, managing all locations and auditing conversations all from one
            portal. Support in our website widget will also allow users to choose which location they are messaging from your
            website.
          </blockquote>
        </v-flex>
        <v-flex xs10 md3 pa-5 order-xs1 order-md2>

            <v-img src='../images/feature/12.png'/>

        </v-flex>
      </v-layout>
      <v-divider class='hidden-sm-and-up'></v-divider>
      <v-layout row wrap fill-height align-center justify-center pa-5>
        <v-flex md3 pa-5>

          <v-img src='../images/feature/10.png' />

        </v-flex>
        <section id="notes"></section>
        <v-flex md5 pa-5>
          <h3 class='display-1 font-weight-medium text-xs-center'>Notes & History</h3>
          <blockquote>
            Conversation Notes provide you with date and time stamped entries on each conversation, allowing you to keep track of your conversation.
            Keep important details about your customer, their order, and any follow up or action items as a result of your conversation. Your History
            details all interactions with the customer as well as who is sending each message and when.
          </blockquote>
        </v-flex>
      </v-layout>
    </v-layout>



    <v-parallax src="./images/parrallax/19.png" height='600' class='hidden-sm-and-down'>

      <v-layout row wrap align-center justify-center fill-height ma-5>
        <v-flex xs11 md8>
          <v-card>
          <v-simple-table fixed-header height='500'>
            <thead>
              <tr>
                <th class="text-left font-weight-medium display-1 white--text MA-5" style="background-color:#0D47A1">Included Features</th>
                <th class="text-center pa-5" style="background-color:#0D47A1">
                  <!-- <h3 class='font-weight-medium display-1 white--text'>Standard</h3>
                  <h3 class='headline font-weight-medium light-blue--text'>$99</h3>
                  <h3 class='font-weight-regular pb-2 white--text'>Per Month<br> $999 Setup/Installation</h3>
                  <v-btn tile color="primary">Sign Up</v-btn> -->
                </th>

              </tr>
            </thead>
            <tbody>
              <tr :key="index" v-for="(ftable, index) in ftable">
                <td>                <div class='subtitle-2'>{{ ftable.feature }}</div>
                                {{ ftable.desc }}</td>
                <td class="text-center">
                  <v-icon color='green'>{{ ftable.icon }}</v-icon>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
        </v-flex>
      </v-layout>

    </v-parallax>

  </div>

</template>

<script>

  export default {
    data() {
      return {
        ftable: [
          {
            feature: 'Engage Desktop Application',
            icon: 'check',
            desc: 'Access Engage right from your desktop or laptop pc anywhere you have internet access.'
          },
          {
            feature: 'Android and iOS Mobile Application',
            icon: 'check',
            desc: 'Mobile ready applications give you access on the go from your mobile device.'
          },
          {
            feature: 'Website Widget',
            icon: 'check',
            desc: 'Be where your customers are, Engage web widget allows your customers to text you right from your website.'
          },
          {
            feature: 'MMS Media Support',
            icon: 'check',
            desc: 'Send and recieve images creating a rich communication experience.'
          },
          {
            feature: 'Notifications',
            icon: 'check',
            desc: 'Keep on top of incoming messages with notifications on desktop and mobile.'
          },
          {
            feature: 'Active Web Sockets',
            icon: 'check',
            desc: 'No need to refresh as Engage automatically detects updates.'
          },
          {
            feature: 'Archived Conversations',
            icon: 'check',
            desc: 'Organize your conversations and keep old conversations for reference.'
          },
          {
            feature: 'Conversation Filter',
            icon: 'check',
            desc: 'Close in on your focused conversations with the use of filters.'
          },
          {
            feature: 'Conversation Search',
            icon: 'check',
            desc: 'Locate conversations quickly and easily.'
          },
          {
            feature: 'Conversation Color Categories',
            icon: 'check',
            desc: 'Color classify your conversations.'
          },
          {
            feature: 'Conversation Notes',
            icon: 'check',
            desc: 'Keep notes on the important details you dont want to forget.'
          },
          {
            feature: 'Unlimited Preset Messages',
            icon: 'check',
            desc: 'Keep a professional and consistent message no matter who is responding.'
          },
          {
            feature: 'Unlimited Users',
            icon: 'check',
            desc: 'No matter the size of your staff provide them the tools to succeed.'
          },
          {
            feature: 'Unlimited Contacts',
            icon: 'check',
            desc: 'Engage grows with your customer base.'
          },
          {
            feature: 'Mutli Location Support',
            icon: 'check',
            desc: 'Manage and access multiple locations with one login.'
          },
          {
            feature: 'SummitCRS Integration',
            icon: 'check',
            desc: 'Integration with Summit Collision Repair System keeping your customers updated.'
          },
          {
            feature: '3rd Party API Support',
            icon: 'check',
            desc: 'Our simple API allows 3rd party applications to utilize the power of Engage.'
          }
        ],
        channels: [
          {
            headline: 'Engage Desktop Application',
            desc: 'Access Engage right from your desktop or laptop pc anywhere you have internet access.',
            icon: 'attach_money',
            link: '#notes'
          },
          {
            headline: 'Android and iOS Mobile Application',
            desc: 'Mobile ready applications give you access on the go from your mobile device.',
            icon: 'business',
            link: '#notes'
          },
          {
            headline: 'Notifications',
            desc: 'Keep on top of incoming messages with notifications on desktop and mobile.',
            icon: 'attach_money',
            link: '#notes'
          },
          {
            headline: 'Website Widget',
            desc: 'Be where your customers are, Engage web widget allows your customers to text you right from your website.',
            icon: 'people',
            link: '#notes'
          }
        ],
        secondchannels: [
          {
            headline: 'Conversation Filter',
            desc: 'Close in on your focused conversations with the use of filters.',
            icon: 'sms',
            link: '#notes'
          },
          {
            headline: 'Preset Messages',
            desc: 'Keep a professional and consistent message no matter who is responding.',
            icon: 'people',
            link: '#notes'
          },
          {
            headline: 'Mutli Location Support',
            desc: 'Manage and access multiple locations with one login.',
            icon: 'attach_money',
            link: '#notes'
          },
          {
            headline: 'Conversation Notes',
            desc: 'Keep notes on the important details you dont want to forget.',
            icon: 'business',
            link: '#notes'
          }
        ]
      }
    }
  }

</script>
